import { Check } from '@mui/icons-material';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { JobSearch } from '@/components/partial/job-search';
import { GoalLabels } from '@/constants/recommendation';
import { Goal } from '@/models/recommendation';
import type { JobTitle } from '@/models/taxonomy/job';

interface OptionsListProps {
  value: Goal;
  onSelect: (value: Goal) => void;
}

const OptionsList = ({ value, onSelect }: OptionsListProps) => (
  <>
    {Object.values(Goal).map((option) => {
      const checked = option === value;
      const handleSelect = () => {
        onSelect(option);
      };

      return (
        <Box key={option}>
          <Chip
            key={option}
            onClick={handleSelect}
            deleteIcon={<Check />}
            color={checked ? 'secondary' : 'default'}
            variant="outlined"
            label={GoalLabels[option]}
            onDelete={checked ? handleSelect : undefined}
          />
        </Box>
      );
    })}
  </>
);

interface EditObjectiveProps {
  onSelect: (value: { goal: Goal; desiredJob?: JobTitle }) => void;
  value: { goal: Goal; desiredJob: JobTitle };
}

export const EditObjective = ({ value, onSelect }: EditObjectiveProps) => {
  const isCareerChange = value.goal === Goal.CareerChange;

  return (
    <>
      <Typography>Objetivo de desenvolvimento</Typography>
      <Stack spacing={1}>
        <OptionsList
          value={value.goal}
          onSelect={(newGoal) => {
            onSelect({
              goal: newGoal,
              desiredJob:
                newGoal === Goal.CareerChange ? value.desiredJob : undefined,
            });
          }}
        />
      </Stack>
      {isCareerChange && (
        <JobSearch
          jobTitle={value.desiredJob ?? undefined}
          onSelect={(newDesiredJob) => {
            onSelect({
              goal: value.goal,
              desiredJob: newDesiredJob ?? undefined,
            });
          }}
        />
      )}
    </>
  );
};
